import { motion, useAnimation } from "framer-motion";
import React, { useEffect, useState } from "react";
import { Col, Grid, Row } from "react-flexbox-grid";

import ContentParagraph from "../../paragraphs/ContentParagraph";
import QuoteParagraph from "../../paragraphs/QuoteParagraph";
import SectionTitle from "../SectionTitle";
import * as styles from "./styles.module.css";

const QuoteSlider = ({ content, title }) => {
  const text = content.filter((c) => c.type === "paragraph__content");
  const quotes = content.filter((c) => c.type === "paragraph__quote");

  const [quoteIndex, setQuoteIndex] = useState(0);
  const maxIndex = text.length;

  const blur = useAnimation();
  const colorFlash = useAnimation();

  useEffect(() => {
    blur.start({ opacity: [0, 1] });
  }, [blur, quoteIndex]);

  useEffect(() => {
    colorFlash.start({ color: [`#f27422`, `#666666`] });
  }, [colorFlash, quoteIndex]);

  const arrowMotionLeft = {
    rest: { x: 0 },
    hover: { x: -10 },
  };
  const arrowMotionRight = {
    rest: { x: 0 },
    hover: { x: 10 },
  };

  return (
    <Grid fluid className={styles.container}>
      <Row className="quotes-slider">
        <Col md={3}>
          <div className={styles.left}>
            <div className="quotes-slider-heading">
              <SectionTitle message={title} white />
            </div>
            <motion.div
              initial={{ opacity: 0 }}
              animate={blur}
              className="quotes-stats"
            >
              <ContentParagraph content={text[quoteIndex]} />
            </motion.div>
          </div>
        </Col>
        <Col md={9}>
          <div className={styles.right}>
            <QuoteParagraph content={quotes[quoteIndex]} />
            <motion.div
              initial={{ y: -60 }}
              whileInView={{ y: 0 }}
              viewport={{ once: true, amount: "all" }}
              transition={{ delay: 0.4 }}
              className={styles.progressbar}
            >
              <div>
                <motion.span animate={colorFlash}>
                  {String(quoteIndex + 1).padStart(2, "0")}
                </motion.span>
                /{String(maxIndex).padStart(2, "0")}
              </div>
              <motion.button
                initial="rest"
                whileHover="hover"
                className={styles.button}
                onClick={() => setQuoteIndex(quoteIndex - 1)}
                disabled={quoteIndex === 0}
                data-direction="left"
                data-quote-position={[quoteIndex + 1]}
              >
                <motion.svg
                  variants={arrowMotionLeft}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
                    fill="var(--orange)"
                  />
                </motion.svg>
                Prev
              </motion.button>
              <input
                type="range"
                min="1"
                max={maxIndex}
                value={quoteIndex + 1}
                onChange={(e) => setQuoteIndex(e.target.value - 1)}
                className={styles.slider}
              />
              <motion.button
                initial="rest"
                whileHover="hover"
                className={styles.button}
                onClick={() => setQuoteIndex(quoteIndex + 1)}
                disabled={quoteIndex === maxIndex - 1}
                data-direction="right"
                data-quote-position={[quoteIndex + 1]}
              >
                Next
                <motion.svg
                  variants={arrowMotionRight}
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
                    fill="var(--orange)"
                  />
                </motion.svg>
              </motion.button>
            </motion.div>
          </div>
        </Col>
      </Row>
    </Grid>
  );
};

export default QuoteSlider;
